<div class="h-100 w-100 d-flex flex-column align-items-center justify-content-center gap-3">
  <div class="d-flex gap-1 flex-column align-items-center">
    <h1 class="m-0 font-size-lg">Page Not Found!</h1>
  </div>
</div>
